// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_intros_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Explore our amazing collection of Intros & Outros and find the perfect one to bring your project to life. Intros are essential to give your content personality and hook the audience from the very first second, while outros can give videos a stylish ending. Find the one that suits your content best and download your royalty free intro!`
};

const de_search_intros_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie unsere beeindruckende Kollektion an Intros und Outros! Finden Sie die perfekte Eröffnungsmusik, damit Ihr Video schon beeindruckend beginnt! Intros sind unerlässlich, um Ihren Inhalten Wiedererkennungswert zu verleihen und Ihr Publikum von der ersten Sekunde an zu begeistern, während Outros Ihren Videos ein stilvolles Ende verleihen können. Finden Sie die Musik, die am besten zu Ihren Inhalten passt - Alle Intro's sind zudem GEMA-frei!`
};

const es_search_intros_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Explora nuestra increíble colección de Intros & Outros y encuentra la pista perfecta para darle vida a tu proyecto. Las intros son esenciales para darle personalidad a tu contenido y enganchar a la audiencia desde el primer segundo, mientras que las outros le darán a tus videos un final perfecto. ¡Encuentra la intro que mejor se adapte a tu contenido!`
};

const pt_br_search_intros_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Explore nossa incrível coleção de introduções e outros e encontre a faixa perfeita para dar vida ao seu projeto. As introduções são essenciais para dar personalidade ao seu conteúdo e envolver o público desde o primeiro segundo, enquanto outras darão aos seus vídeos um final perfeito. Encontre a faixa que melhor se adapta ao seu conteúdo!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "pt-br" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_intros_home_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_intros_home_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_intros_home_subtitle", locale)
	if (locale === "en") return en_search_intros_home_subtitle(inputs)
	if (locale === "de") return de_search_intros_home_subtitle(inputs)
	if (locale === "es") return es_search_intros_home_subtitle(inputs)
	return pt_br_search_intros_home_subtitle(inputs)
};
export { search_intros_home_subtitle as "search.intros-home-subtitle" }